/* RESPONSIBLE TEAM: team-conversations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-controllers */
/* eslint-disable ember/no-classic-classes */
import { computed } from '@ember/object';
import { alias, gt, and, empty } from '@ember/object/computed';
import Controller, { inject as controller } from '@ember/controller';
import SegmentActions from 'embercom/controllers/mixins/users-and-companies/segment-actions';
import SegmentQueryParams from 'embercom/controllers/mixins/users-and-companies/segment-query-params';
import TrackFilteringEvents from 'embercom/controllers/mixins/users-and-companies/track-filtering-events';
import { ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import { action } from '@ember/object';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import { inject as service } from '@ember/service';

export default Controller.extend(SegmentActions, SegmentQueryParams, TrackFilteringEvents, {
  place: 'user_list',
  appController: controller('apps/app'),
  app: alias('appController.model'),
  router: service(),
  hasStandardPredicates: gt('model.activePredicates.length', 0),
  hasNestedPredicates: gt('model.nestedPredicates.length', 0),
  hasValidPredicates: ternaryToProperty(
    'model.isNestedGroup',
    'hasNestedPredicates',
    'hasStandardPredicates',
  ),

  isDirtyAndHasValidPredicates: and('model.hasDirtyAttributes', 'hasValidPredicates'),

  searchController: controller('apps.app.users'),
  searchModel: alias('searchController.search'),
  searchEmpty: empty('searchModel.text'),
  searchActive: alias('searchController.searchActive'),

  createSegment(segment) {
    this.send('createSegment', segment);
  },

  handleWarnOnNavigation: action(function (shouldWarnOnNavigation) {
    this.send('warnOnNavigation', shouldWarnOnNavigation);
  }),

  newHeroBannerActions: computed('router', function () {
    return [
      {
        type: 'link',
        label: 'apps.app.users.segments.new-banner.actions.article-get-started-with-contacts',
        icon: 'article',
        analyticsId: 'get-started-with-contacts-article',
        onClick: () => {
          window.Intercom('showArticle', 215); // https://www.intercom.com/help/en/articles/215-get-started-with-contacts
        },
      },
      {
        type: 'link',
        label:
          'apps.app.users.segments.new-banner.actions.article-tracking-and-grouping-your-customers',
        icon: 'article',
        analyticsId: 'tracking-and-grouping-your-customers-article',
        onClick: () => {
          safeWindowOpen(
            'https://www.intercom.com/help/en/collections/2094815-tracking-filtering-grouping-your-customers',
            '_blank',
          );
        },
      },
      {
        type: 'link',
        label: 'apps.app.users.segments.new-banner.actions.article-using-apps-and-integrations',
        icon: 'article',
        analyticsId: 'using-apps-and-integrations-article',
        onClick: () => {
          safeWindowOpen(
            'https://www.intercom.com/help/en/collections/2094744-apps-integrations',
            '_blank',
          );
        },
      },
      {
        type: 'link',
        label: 'apps.app.users.segments.new-banner.actions.link-visit-app-store',
        icon: 'reference',
        analyticsId: 'visit-app-store-article',
        onClick: () => {
          let url = this.router.urlFor('apps.app.settings.app-settings.app-store');
          safeWindowOpen(url, '_blank');
        },
      },
    ];
  }),

  actions: {
    segmentFiltersChanged(action) {
      this.send('addFiltersToUrl', this.model);
      this.processEvent(action);
    },
  },
});
